module.exports = __webpack_public_path__ + "fonts/TTMarxiana-Antiqua.fdad29f4.ttf";